export default __webpack_public_path__ + "static/media/Elon_Musk.478f936b.jpg";